// @flow strict
import { useStaticQuery, graphql } from "gatsby"

const useRecentPosts = () => {
  const { recentPosts } = useStaticQuery(
    graphql`
      query RecentPostsBySlug {
        recentPosts: allMdx(
          limit: 5
          sort: { frontmatter: { rewrite: DESC } }
          filter: { frontmatter: { date: { ne: null } } }
        ) {
          nodes {
            fields {
              slug
            }
            frontmatter {
              title
              thumbnail {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `
  )

  return recentPosts
}

export default useRecentPosts
